import React from 'react'
import CustomAmount from './CustomAmount'
import TipAmount from './TipAmount'

export default function CustomPayment({
    payment,
    customAmount,
    isTipRefunded,
    isVisible=false,
    includesTip,
    maxRefundableAmount=0,
    className=null,
    setCustomAmount=() => {},
    setIncludesTip=() => {},
}) {
    return isVisible && (
        <div className={`row ${className}`}>
            <div className='col-12 col-md-6'>
                {
                    <CustomAmount
                        isVisible={maxRefundableAmount > 0}
                        maxRefundableAmount={maxRefundableAmount}
                        customAmount={customAmount}
                        setCustomAmount={setCustomAmount}
                    />
                }
            </div>
            <div className='col-12 col-md-6'>
                <TipAmount
                    isVisible={payment.tip_cents > 0 && !isTipRefunded}
                    payment={payment}
                    className='mt-2'
                    includesTip={includesTip}
                    setIncludesTip={setIncludesTip}
                />
            </div>
        </div>
    )
}
